"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));
var _react = _interopRequireDefault(require("react"));
var _underscore = _interopRequireDefault(require("underscore"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Square icon button with toggle logic
 */
function SquareIconButton(props) {
  const {
    title,
    id,
    label,
    onClick,
    tooltipPlacement = "top"
  } = props;
  const defaultIconButtonStyle = {
    borderRadius: 0
  };
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    id: id,
    title: title,
    placement: tooltipPlacement,
    disableInteractive: true
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, _extends({
    disableFocusRipple: true,
    disableTouchRipple: true,
    size: "large",
    key: id,
    "aria-label": label || title.toLowerCase(),
    onClick: onClick,
    sx: defaultIconButtonStyle
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, _underscore.default.omit(props, "title", "tooltipPlacement", "id", "label", "onClick", "isToggleable", "isToggled"))));
}
var _default = exports.default = SquareIconButton;